import { useInfiniteQuery } from '@gogame/query';

import { loadSmartRuleActionsLog } from 'scenes/SmartRules/sources/smartRules';

import { actionLogs } from './queryKeyFactory';

const LIMIT = 10;

export const useSmartRuleActionsLog = (params) => {
  return useInfiniteQuery(
    actionLogs(params),
    ({ pageParam }) => {
      return loadSmartRuleActionsLog({
        ...params,
        offset: pageParam,
        limit: LIMIT,
      });
    },
    {
      getNextPageParam: (lastPage, pages) => {
        const count = lastPage.count;
        const index = pages.indexOf(lastPage);
        const current = pages
          .slice(0, index + 1)
          .reduce((a, p) => a + p.rows.length, 0);
        const pageCount = Math.ceil(count / LIMIT);

        if (index + 1 < pageCount) {
          return current;
        }
        return undefined;
      },
    }
  );
};
